import MarkdownText from "@galaxy-io/dls/text/MarkdownText";
import Text, { TextSize, TextWeight } from "@galaxy-io/dls/text/Text";
import { styled } from "@linaria/react";
import type { ReactNode } from "react";
import { sourceMarkdown } from "@/lib/markdown";

const Content = styled.div`
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  img {
    max-width: 100%;
    height: auto;
  }
  pre {
    overflow-x: auto;
    max-width: 100%;
  }
`;
const headings = Object.fromEntries(
  [
    TextSize.HEADING_LG,
    TextSize.HEADING_MD,
    TextSize.HEADING_SM,
    TextSize.BODY_LG,
    TextSize.BODY_MD,
    TextSize.BODY_SM,
  ].map((size, index) => [
    `h${index + 1}`,
    function Heading({ children }: { children?: ReactNode }) {
      return (
        <div role="heading" aria-level={index + 1}>
          <Text size={size} weight={TextWeight.MEDIUM} isSelectable>
            {children}
          </Text>
        </div>
      );
    },
  ]),
);
export function SourceMarkdown({ content, breaks }: { content: string; breaks?: boolean }) {
  return (
    <Content>
      <MarkdownText content={sourceMarkdown(content, { breaks })} componentOverrides={headings} />
    </Content>
  );
}
